module.exports = __webpack_public_path__ + "img/featured-tag.00ea4251.svg";